import { createApp } from 'vue'
import money from 'v-money3'
import axios from 'axios'
import { createPinia } from 'pinia';
import App from './App.vue'
import router from './router'
import { TokenStorage } from './services/apiConfig'
import CustomPagination from './components/CustomPagination.vue'
import CustomButton from './components/CustomButton.vue'
import MarketCardProduct from './views/market/components/MarketCardProduct.vue'
import '../public/styles/globals.css'
import '../public/styles/skeleton.css'
import '../public/styles/animation.css'
import '../public/styles/web-ui.css'
import '../public/styles/web-components.css'
import '../public/styles/user-ui.css'
import '../public/styles/globals-coop-finance.css'
import '../public/styles/loader.css'
import CustomModal from './components/CustomModal.vue';

// S'assurer que backendUrl ne contient pas /api à la fin
const backendUrlRaw = process.env.VUE_APP_API_URL || 'https://backend.coop-finance-app.wixoon.dev'
const backendUrl = backendUrlRaw.replace(/\/api$/, '') // Retirer /api s'il est présent
axios.defaults.baseURL = `${backendUrl}/api`
axios.defaults.withCredentials = true
axios.defaults.withXSRFToken = true

// Intercepteur pour ajouter le token aux requêtes
axios.interceptors.request.use(
  (config) => {
    const token = TokenStorage.getToken()
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Intercepteur pour gérer les erreurs de réponse
axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    const errorResponseData = {
      axioserrorcode: error.code,
      message: error.response?.data?.message ? error.response.data.message : 'Une erreur est survenue lors de la requête au serveur',
      stacktrace: error.response?.data?.stacktrace ? error.response.data.stacktrace : null,
      httpstatuscode: error.response?.status || error.response?.data?.httpstatuscode || null,
    }
    
    // Gestion de l'erreur 401 (non autorisé)
    if (errorResponseData.httpstatuscode === 401) {
      const token = TokenStorage.getToken()
      if (token) {
        // Déconnexion côté serveur si possible
        axios.post('/backoffice/auth/signout', {}, { headers: { Authorization: `Bearer ${token}` } }).catch(() => {
          // Ignorer les erreurs de déconnexion
        })
        TokenStorage.clear()
      }
      router.replace('/auth/sign-in')
    }
    
    return Promise.reject(errorResponseData)
  }
)

const app = createApp(App)
app.provide('BACKEND_URL', backendUrl);
app.component('custom-modal', CustomModal);
app.component('custom-pagination', CustomPagination);
app.component('custom-button', CustomButton);
app.component('MarketCardProduct', MarketCardProduct)
app.use(router).use(money).use(createPinia()).mount('#app')
